import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { ShieldCheck } from 'lucide-react';

const Badge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  padding: 0 12px;
  border-radius: 99px;
  border: 1px solid ${({ theme }) => theme.colors.border.subtle};
  background-color: ${({ theme, $enabled }) => ($enabled ? theme.colors.green[20] : theme.colors.neutral[20])};
  color: ${({ theme }) => theme.colors.text.dark};
`;

const Label = styled.span`
  font-size: 14px;
  font-weight: 500;
  line-height: 24px;
`;

const BadgeIcon = styled(ShieldCheck)`
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  color: ${({ theme }) => theme.colors.green[600]};
`;

const MfaStatusBadge = ({ enabled }) => (
  <Badge $enabled={enabled}>
    {enabled && <BadgeIcon aria-hidden />}
    <Label>{enabled ? 'Enabled' : 'Not enabled'}</Label>
  </Badge>
);

MfaStatusBadge.propTypes = {
  enabled: PropTypes.bool.isRequired,
};

export default MfaStatusBadge;
